import React, { useState, useEffect } from 'react';
import {
  Typography,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
} from '@mui/material';

const UserPasswordReset = ({ user, handleClose, handleResetPassword }) => {
  const [record, setRecord] = useState({});

  useEffect(() => {
    setRecord(user);
  }, [user]);

  return (
    <Dialog
      open={true}
      onClose={(event, reason) => reason === 'backdropClick' || handleClose()}
      disableEscapeKeyDown
    >
      <DialogTitle>
        {record.userStatus === 'FORCE_CHANGE_PASSWORD'
          ? 'Resend Invitation?'
          : 'Reset Password?'}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {record.userStatus === 'FORCE_CHANGE_PASSWORD'
            ? `Are you sure you want to resend the invitation for the user, ${record.username}?`
            : `Are you sure you want to reset the password for the user, ${record.username}?`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            handleResetPassword(record);

            handleClose(e);
          }}
        >
          OK
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserPasswordReset;
